import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { getStripePublishableKey } from "../../api";

// Initialize Stripe outside of the component to avoid recreating it on every render
const stripePromise = loadStripe(getStripePublishableKey());

/**
 * StripeProvider Component
 * Provides Stripe context to child components
 * Issue #16: PCI Compliance
 *
 * This component ensures we handle card data securely by using Stripe's hosted
 * components for collecting payment information, keeping our system PCI compliant
 * by not handling any raw card data on our servers.
 */
const StripeProvider = ({ children, options = {} }) => {
  // Default options for Stripe Elements
  const defaultOptions = {
    fonts: [
      {
        cssSrc:
          "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap",
      },
    ],
    appearance: {
      theme: "stripe",
      variables: {
        colorPrimary: "#0d6efd", // Bootstrap primary color
        colorBackground: "#ffffff",
        colorText: "#212529", // Bootstrap dark text
        colorDanger: "#dc3545", // Bootstrap danger color
        fontFamily: "Inter, system-ui, sans-serif",
        spacingUnit: "4px",
        borderRadius: "4px",
      },
    },
  };

  // Merge default options with any provided options
  const elementOptions = { ...defaultOptions, ...options };

  return (
    <Elements stripe={stripePromise} options={elementOptions}>
      {children}
    </Elements>
  );
};

export default StripeProvider;
